/**
 * A drop-in component to listen for resizes or scroll-bar show/hide
 *
 * The idea is to add a 100% width invisible iframe to the page and
 * listen for resize events on it's internal window. These events
 * will pick up changes not only to the outer window's size but also
 * when scrollbars get added to or removed from the outer window.
 *
 * It triggers a regular window resize event so it requires no extra code
 * if you are already listening for window resize.
 *
 * Based on https://gist.github.com/OrganicPanda/8222636
 */
import React from 'react';

class ScrollBarAdapter extends React.Component {
  constructor() {
    super();
    this.onResize = this.onResize.bind(this);
  }

  onResize() {
    if (this.props.onResize) {
      this.props.onResize();
      return;
    }
    try {
      const event = new UIEvent('resize');
      window.dispatchEvent(event);
    } catch (e) {}
  }

  componentDidMount() {
    this.frame.contentWindow.addEventListener('resize', this.onResize, false);
  }

  componentWillUnmount() {
    this.frame.contentWindow.removeEventListener('resize', this.onResize);
  }

  render() {
    const style = {
      height: 0,
      margin: 0,
      padding: 0,
      overflow: 'hidden',
      borderWidth: 0,
      position: 'absolute',
      backgroundColor: 'transparent',
      width: '100%',
    };

    return (
      <iframe
        title="Scroll Bar Adapter"
        className="ScrollBarAdapter"
        ref={frame => {
          this.frame = frame;
        }}
        style={style}
      />
    );
  }
}

export default ScrollBarAdapter;
